export default __webpack_public_path__ + "static/cloud-e4513e555e1fd9acf718e4460cabd8e9.gif";